import GetData from './getDataClass';

export default async function createMapping(token){
    let getData = new GetData(token);
    let promiseArray = [
                            getData.getDisputeStatusList(),
                            getData.getHubZone(),
                            getData.getHubList(),
                            getData.getBucketList(),
                            getData.hubzoneByHubId(),
                            getData.getReasonListB2B(),
                            getData.getStatustList(),
                            getData.getActionStatusCodeList()

                        ];

        promiseArray.forEach(promise => {
            promise.then(res => {
                window.localStorage.setItem(res.name, JSON.stringify(res.map));
            }); 
        });
}


// WEBPACK FOOTER //
// ./src/Mappings/getCommonFunctionMaps.js